import type { IRealtimeEvent } from './RealtimeEvent.js';
import { type FluidPrefixType } from './fluid.js';

export class DispatchEvent<T extends IRealtimeEvent<any, any>> {
  public readonly fluid: FluidPrefixType;

  public readonly event: T;

  public constructor(fluid: FluidPrefixType, event: T) {
    this.event = event;
    this.fluid = fluid;
  }

  public toJSON() {
    return JSON.stringify({
      // eslint-disable-next-line id-length
      f: this.fluid,
      // eslint-disable-next-line id-length
      e: this.event.toJSONObject(),
    });
  }
}
